import { render, staticRenderFns } from "./ClientBotView.vue?vue&type=template&id=559f1a3e&"
import script from "./ClientBotView.vue?vue&type=script&lang=js&"
export * from "./ClientBotView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports